import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-report-modal',
  templateUrl: './report-modal.component.html',
  styleUrls: ['./report-modal.component.scss'],
})
export class ReportModalComponent implements OnInit {
  getReportForm: FormGroup;
  isSubmited: boolean = false;
  specialityId;
  specialityName;
  specialityArName;

  public event: EventEmitter<any> = new EventEmitter();

  constructor(
    public bsModalRef: BsModalRef,
    private _formBuilder: FormBuilder,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.getReportForm = this._formBuilder.group({
      reportPeriod: [null, [Validators.required]],
    });
  }

  reCreateDateRangeObject(dateRange) {
    const FromDate = dateRange.reportPeriod[0];
    const FromYear = FromDate.getFullYear();
    const FromMonth =
      FromDate.getMonth() < 9
        ? `0${FromDate.getMonth() + 1}`
        : FromDate.getMonth() + 1;
    const FromDay =
      FromDate.getDate() < 10 ? `0${FromDate.getDate()}` : FromDate.getDate();
    const FromDateString = `${FromYear}-${FromMonth}-${FromDay}`;

    const ToDate = dateRange.reportPeriod[1];
    const ToYear = FromDate.getFullYear();
    const ToMonth =
      ToDate.getMonth() < 9
        ? `0${ToDate.getMonth() + 1}`
        : ToDate.getMonth() + 1;
    const ToDay =
      ToDate.getDate() < 10 ? `0${ToDate.getDate()}` : ToDate.getDate();
    const ToDateString = `${ToYear}-${ToMonth}-${ToDay}`;

    return {
      FromDateString,
      ToDateString,
    };
  }

  onGetReportSubmit() {
    const dateRange = this.reCreateDateRangeObject(this.getReportForm.value);

    this.router.navigate(
      ['specialties', this.specialityId],
      {
        queryParams: {
          FromDate: dateRange.FromDateString,
          ToDate: dateRange.ToDateString,
        },
      },
    );

    this.bsModalRef.hide();
  }
}
